import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import CompanyUserListForm from '@src/features/company/company-user/CompanyUserListForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyUserList() {
  return (
    <CompanyGuard canRoles={[COMPANY_ROLE.ADMIN]}>
      <CompanyDefaultLayout pageName='users'>
        <CommonHelmet />
        <CompanyUserListForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyUserList;
